import { orderedOptions, optionLabel } from "../../configurazione/adapters";
import React from 'react';

const hasEmptyOption = (dati) =>
    Array.isArray(dati) &&
    dati.some((dato) => {
        if (dato && typeof dato === "object") {
            return dato.value === "";
        }
        return dato === "";
    });

function CampoRicercaAvanzata({
    nomeCampo,
    labelCampo,
    tipo,
    value,
    handleChange,
    handleKeyDown,
    dati,
    divClass,
    placeholder,
    inputStyle
}) {
    const opzioni = orderedOptions(dati);
    if (value !== "" && value !== null && value !== undefined && !opzioni.some(o => String(o && typeof o === "object" ? o.value : o) === String(value))) {
        opzioni.push(tipo === "tendinaDati" ? { value, desc: `${value} (selezione precedente)` } : value);
    }


    if (tipo === "testo") {
        return (
            <div className={divClass}>
                <label className='mr1 b nonSelezionabile' for={nomeCampo}>{labelCampo}</label>
                <input
                    value={value}
                    name={nomeCampo}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    id={nomeCampo}
                    className="input-reset inputOrizzontale"
                    type="text"
                    placeholder={placeholder || ""}
                    style={inputStyle}
                    aria-describedby="name-desc"
                    autoComplete="off" />
            </div>    
        )
    } else if (tipo === "tendina") {
        return(<div className={divClass}>
        <label className='mr1 b nonSelezionabile' for={nomeCampo}>{labelCampo}</label>
        <select
            name={nomeCampo}
            id={nomeCampo}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            value={value}
                    className="inputOrizzontale"
        >
        {!hasEmptyOption(dati) && <option key="1" value="" selected="selected"></option>}      
        {
            opzioni.map((dato,ind) => <option key={ind+1} value={dato} >{optionLabel(dati, dato)}</option>)
        }                  
        </select> 
    </div>)
    } else if (tipo === "tendinaDati") {
        return(<div className={divClass}>
                <label className='mr1 b nonSelezionabile' for={nomeCampo}>{labelCampo}</label>
                <select
                    name={nomeCampo}
                    id={nomeCampo}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={value}
                    className="inputOrizzontale"
                >
                {!hasEmptyOption(dati) && <option key="1" value="" selected="selected"></option>}      
                {
                    opzioni.map((dato,ind) => <option key={ind+1} value={dato.value} >{dato.desc}</option>)
                }                  
                </select> 
            </div>)   
    } else if (tipo === "data") {
        return(<div className={divClass}>
            <label className='mr1 b nonSelezionabile' for={nomeCampo}>{labelCampo}</label>
            <input
                value={value}
                name={nomeCampo}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                id={nomeCampo}
                className="input-reset inputOrizzontale"
                type="date"
                aria-describedby="name-desc"
                autoComplete="off" />
        </div>)
    } else if (tipo === "bool") {
        //tendina si no
        return(<div className={divClass}>
            
        <div>boolean</div>
        </div>)
    }    
}


export default CampoRicercaAvanzata;
